/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type OpportunityEntity, opportunitySchema } from '@axiom/domain';
import { ownerUserSchema } from './owner-user';
import { reputationAccountSchema } from './reputation-account';

export const reputationOpportunitySchema = opportunitySchema.pick({ "id": true, "jobName": true }).extend({ "account": z.lazy(() => reputationAccountSchema).nullish(), "ownerUser": z.lazy(() => ownerUserSchema).nullish(), "salesLead": z.lazy(() => ownerUserSchema).nullish() });
export type ReputationOpportunity = Pick<OpportunityEntity, "id" | "jobName"> & z.infer<typeof reputationOpportunitySchema>;
